import MemberWalletMain from "../../components/members-wallet-balance/MemberWalletMain"

export const MemberWalletBalace = ({ title_1, title_2, title }) => {
   
    return <div>
        <MemberWalletMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}